import { PriorToTypes } from './condition';
import { TaskAssignmentType, TaskAssignmentTypeLabel } from './tasks';

export const LoanSummaryDrilldownParam = {
  TASK_AUDIENCE: 'taskAudience',
  CONDITION_PRIOR_TO: 'conditionPriorTo',
  CONDITION_STATUS: 'conditionStatus',
};

export const TaskAudience = {
  BORROWER: 'borrower',
  INTERNAL: 'internal',
};

export const TASK_AUDIENCE_COLUMN_KEY = 'taskTypeLabel';

export const TaskAudienceColumnValues = {
  [TaskAudience.BORROWER]: [
    TaskAssignmentTypeLabel[TaskAssignmentType.BORROWER],
    TaskAssignmentTypeLabel[TaskAssignmentType.SUB_COMPANY],
    TaskAssignmentTypeLabel[TaskAssignmentType.SUB_COMPANY_USER],
  ],
  [TaskAudience.INTERNAL]: [TaskAssignmentTypeLabel[TaskAssignmentType.SLA_GROUP]],
};

export const CONDITION_STATUS_OPEN = 'open';

export const DRILLDOWN_PRIOR_TO_TYPES = [PriorToTypes.DOC, PriorToTypes.FUNDING];
